import React, { useState, useEffect } from "react";
import { IMG_MOON, toastFail } from "../../config";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "../../index.css";
import "./SlackLanding.css";
import { apiSlackAuth } from "../../services/OAuthService";
import { CircularProgress } from "@mui/material";
import { apiGetUser } from "../../api";
import { selectUser, setUser } from "../../redux/features/appData";
import { TRACK_EVENTS, trackAnalyticsEvent } from "../../hooks/useAnalytics";
import config from "environment";
import toast from "react-hot-toast";

export default function SlackLanding() {
  const workspaceId = useSelector(selectUser)?.currentWorkspaceId;

  const storeUser = useSelector(selectUser);
  const dispatch = useDispatch();

  const userId = useSelector(selectUser)?.id;
  const [statusText, setStatusText] = useState<string>("Loading...");
  const [showProgress, setShowProgress] = useState<boolean>(true);

  const codeFromSlack = new URLSearchParams(window.location.search).get("code");
  const navigate = useNavigate();

  const authSlack = async (
    code: string,
    userId: string,
    workspaceId: string
  ) => {
    const result = await apiSlackAuth(code, userId, workspaceId);

    if (result) {
      setStatusText("Slack is Authed!");
      const apiUser = await apiGetUser(userId);
      dispatch(setUser(apiUser));
      navigate("/workspaces");
    } else {
      setStatusText("Slack auth failed! 😢");
      setShowProgress(false);
    }
  };

  useEffect(() => {
    //get code from html somehow...
    //const code = ...
    if (codeFromSlack && userId && workspaceId) {
      authSlack(codeFromSlack, userId, workspaceId);
      trackAnalyticsEvent(
        TRACK_EVENTS.CompletedSlackIntegration,
        {},
        storeUser
      );
    } else {
      setStatusText("Missing information from slack redirect");
      toast("Slack auth failed!", toastFail);
      navigate("/workspaces");
    }
  }, []);

  return (
    <div id="slack-landing-page">
      <div className="slack-landing-page-body">
        <div className="slack-landing-page-text">
          <h1>We're working on Authing Slack for you!</h1>
        </div>
        <div className="slack-landing-status-text">Status: {statusText}</div>

        {showProgress && <CircularProgress />}
        {!showProgress && (
          <div className="slack-landing-status-button">
            <button onClick={() => navigate("/settings")}>
              Go To Settings
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
